module.exports = __webpack_public_path__ + "static/media/angle-right-white.e7a48e3d.svg";